import api from './api';

// Function to set up interceptors
function setupInterceptors(navigate, logout) {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.code === 'ERR_NETWORK') {
        navigate('/error', { replace: true, state: { message: 'The server can not be reached.' } });
        return Promise.resolve
      }
      switch (error.response?.status) {
        case 400:
          switch (error.response.data?.error) {
            case 'wrong_username':
              throw error;
            case 'wrong_format':
              return Promise.reject(error);
            case 'wrong_password':
              throw error;
            case 'not_readable':
            default:
              console.warn('Caught 400 error', error.response.data?.error);
              navigate('/error', { replace: true, state: { message: error.response.data?.message } });
              return Promise.resolve(error);
          }
        case 401:
          switch (error.response.data?.error) {
            case 'bad_credentials':
              return Promise.reject(error);
            case 'expired':
            case 'invalid':
            case 'bad_signature':
            case 'missing_token':
            case 'revoked':
            default:
              console.warn('Caught 401 error', error.response.data?.error, error.response.data?.message);
              navigate('/error', { replace: true, state: { message: error.response.data?.message } });
              return Promise.resolve(error);
          }
        case 403:
          switch (error.response.data?.error) {
            case 'archived':
              console.error('Caught', error.respone?.data?.error, error.response?.data?.message);
              return Promise.reject(error);
            case 'missing_token':
            case 'access_denied':
            default:
              navigate('/error', { replace: true, state: { message: error.response.data?.message } });
              return Promise.resolve(error);
          }
        case 409:
          console.warn('Caught 409:', error, error.response?.data?.error, error.response?.data?.message);
          return Promise.reject(error);
        default:
          console.warn('Unhandled error status', error.response?.status, error);
          navigate('/error', { replace: true, state: { message: error.response.data?.message } });
          return Promise.reject(error);
      }
    }
  );
};

export default setupInterceptors;
export { setupInterceptors };